export default __webpack_public_path__ + "static/media/quyenthiet.2b3ec409.png";